import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e0ff705e")

_pushScopeId("data-v-e0ff705e")
const _hoisted_1 = { class: "d-flex align-items-center mb-2 gap-2" }
const _hoisted_2 = {
  key: 0,
  class: "fw-semibold text-gray-800 fs-7"
}
const _hoisted_3 = { class: "text-muted fs-8" }
const _hoisted_4 = {
  key: 1,
  class: "fw-semibold text-gray-800 fs-7"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["d-flex mb-8", _ctx.isOutgoing ? 'justify-content-end' : 'justify-content-start']
  }, [
    _createVNode("div", {
      class: ["d-flex flex-column", _ctx.isOutgoing ? 'align-items-end' : 'align-items-start'],
      style: {"max-width":"75%"}
    }, [
      _createVNode("div", _hoisted_1, [
        (!_ctx.isOutgoing)
          ? (_openBlock(), _createBlock("span", _hoisted_2, _toDisplayString(_ctx.senderLabel), 1))
          : _createCommentVNode("", true),
        _createVNode("span", _hoisted_3, _toDisplayString(_ctx.timeLabel), 1),
        (_ctx.isOutgoing)
          ? (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(_ctx.senderLabel), 1))
          : _createCommentVNode("", true)
      ]),
      (_ctx.attachmentItems.length)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: ["d-flex flex-column gap-3 mb-3", _ctx.isOutgoing ? 'align-items-end' : 'align-items-start']
          }, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.attachmentItems, (attachment, index) => {
              return (_openBlock(), _createBlock("div", {
                key: `${attachment.url}-${index}`,
                class: "inbox-message-attachment"
              }, [
                (_ctx.isImageAttachment(attachment))
                  ? (_openBlock(), _createBlock("img", {
                      key: 0,
                      src: attachment.url,
                      alt: attachment.filename || 'Attachment',
                      class: "inbox-message-attachment__image"
                    }, null, 8, ["src", "alt"]))
                  : (_ctx.isVideoAttachment(attachment))
                    ? (_openBlock(), _createBlock("video", {
                        key: 1,
                        src: attachment.url,
                        controls: "",
                        class: "inbox-message-attachment__video"
                      }, null, 8, ["src"]))
                    : (_openBlock(), _createBlock("a", {
                        key: 2,
                        href: attachment.url,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        class: "btn btn-sm btn-light"
                      }, _toDisplayString(attachment.filename || 'Open attachment'), 9, ["href"]))
              ]))
            }), 128))
          ], 2))
        : _createCommentVNode("", true),
      (_ctx.hasTextContent)
        ? (_openBlock(), _createBlock("div", {
            key: 1,
            class: ["p-4 rounded fw-semibold inbox-message-bubble", _ctx.bubbleClass],
            innerHTML: _ctx.formattedContent
          }, null, 10, ["innerHTML"]))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
})